import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductShortcutFeaturesComponent } from './product-shortcut-features.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';

@NgModule({
  declarations: [ProductShortcutFeaturesComponent],
  imports: [CommonModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductShortcuts: {
          component: ProductShortcutFeaturesComponent,
        },
      },
    }),
  ],
})
export class ProductShortcutFeaturesModule {}
